export const ROUTE_SEGMENTS = {
  catalog: 'catalog',
  pricing: 'pricing',
  cart: 'shop-v2/cart',
  cartV1: 'shop/cart',
  checkoutV1: 'shop/checkout',
  checkout: 'shop-v2/checkout',
  accountV1: 'account',
  account: 'account-v2',
  accountTypo3: 'my-account',
  search: 'search',
};

//Setting up account links to link properly to both ni-v1 and typo3 pages
//Will link properly as pages are migrated
export const ROUTE_PATHS = {
  pricing: `/:language/${ROUTE_SEGMENTS.pricing}/:url_key/`,
  cart: `/:language/${ROUTE_SEGMENTS.cart}/`,
  cartV1: `/:language/${ROUTE_SEGMENTS.cartV1}/`,
  catalog: `/:language/${ROUTE_SEGMENTS.catalog}/`,
  search: `/:language/${ROUTE_SEGMENTS.search}/`,

  // Account
  account: `/:language/${ROUTE_SEGMENTS.accountV1}/`,
  accountV2: `:language/${ROUTE_SEGMENTS.account}/`,
  accountTypo3: `:language/${ROUTE_SEGMENTS.accountTypo3}`,
  accountSettings: `/:language/${ROUTE_SEGMENTS.accountV1}/settings`,
  orders: `/:language/${ROUTE_SEGMENTS.accountV1}/orders/`,
  orderDetail: `/:language/${ROUTE_SEGMENTS.account}/orders/:orderNumber/`,
  productsSerialsDownloads: `/:language/${ROUTE_SEGMENTS.accountTypo3}/my-products-serials-downloads`,
  subscription: `/:language/${ROUTE_SEGMENTS.accountV1}/subscription`,
  licenseTransfer: `/:language/${ROUTE_SEGMENTS.accountTypo3}/license-transfer`,

  // Checkout
  checkout: `/:language/${ROUTE_SEGMENTS.checkout}/`,
  address: `/:language/${ROUTE_SEGMENTS.checkout}/address/`,
  addressV1: `/:language/${ROUTE_SEGMENTS.checkoutV1}/address/`,
  delivery: `/:language/${ROUTE_SEGMENTS.checkout}/delivery/`,
  deliveryV1: `/:language/${ROUTE_SEGMENTS.checkoutV1}/delivery/`,
  payment: `/:language/${ROUTE_SEGMENTS.checkout}/payment/:status?/:orderCartId?`,
  review: `/:language/${ROUTE_SEGMENTS.checkout}/review/`,
  reviewV1: `/:language/${ROUTE_SEGMENTS.checkoutV1}/review/`,
  success: `/:language/${ROUTE_SEGMENTS.checkout}/success/:orderNumber/`,
  successV1: `/:language/${ROUTE_SEGMENTS.checkoutV1}/success/:orderNumber/`,
};
